export const LOCALE_KEY = 'LOCALE'
